"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SmartWatchSquareBrightnessAlternate: ['smart-watch-square-brightness-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,3H16.922a.249.249,0,0,1-.24-.182L15.98.364A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.362l-.7,2.456A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3V6A3,3,0,0,0,18,3Zm1,15a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M9.750 12.252 A2.000 2.000 0 1 0 13.750 12.252 A2.000 2.000 0 1 0 9.750 12.252 Z', 'M13.000 8.002 A1.000 1.000 0 1 0 15.000 8.002 A1.000 1.000 0 1 0 13.000 8.002 Z', 'M8.500 8.002 A1.000 1.000 0 1 0 10.500 8.002 A1.000 1.000 0 1 0 8.500 8.002 Z', 'M13.000 16.002 A1.000 1.000 0 1 0 15.000 16.002 A1.000 1.000 0 1 0 13.000 16.002 Z', 'M15.500 12.002 A1.000 1.000 0 1 0 17.500 12.002 A1.000 1.000 0 1 0 15.500 12.002 Z', 'M6.000 12.002 A1.000 1.000 0 1 0 8.000 12.002 A1.000 1.000 0 1 0 6.000 12.002 Z', 'M8.500 16.002 A1.000 1.000 0 1 0 10.500 16.002 A1.000 1.000 0 1 0 8.500 16.002 Z']],
  SmartWatchCircleHeartAlternate: ['smart-watch-circle-heart-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M12.676,9.025l-.5.5a.25.25,0,0,1-.353,0l-.5-.5A2.449,2.449,0,0,0,7.86,12.489l3.959,4.13a.25.25,0,0,0,.361,0l3.959-4.13a2.449,2.449,0,0,0-3.463-3.464Z']],
  SmartWatchSquareBell: ['smart-watch-square-bell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-9,10.5a.5.5,0,0,1,0-1A.5.5,0,0,0,9,13V11a3,3,0,0,1,6,0v2a.5.5,0,0,0,.5.5.5.5,0,0,1,0,1Zm4.8,1.75a1.5,1.5,0,0,1-2.6,0,.5.5,0,0,1,.433-.75h1.733a.5.5,0,0,1,.432.75Z']],
  SmartWatchSquareData: ['smart-watch-square-data', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM16,13.219a.656.656,0,0,1,.513,1.066l-1.75,2.187a.656.656,0,0,1-1.026,0l-1.75-2.187a.656.656,0,0,1,.513-1.066h.75a.25.25,0,0,0,.25-.25V10.031a.75.75,0,1,1,1.5,0v2.938a.25.25,0,0,0,.25.25ZM7.5,10.344a.657.657,0,0,1-.513-1.067L8.737,7.09a.681.681,0,0,1,1.026,0l1.75,2.187A.657.657,0,0,1,11,10.344h-.75a.249.249,0,0,0-.25.25v3.437a.75.75,0,0,1-1.5,0V10.594a.249.249,0,0,0-.25-.25Z']],
  SmartWatchSquareDownload: ['smart-watch-square-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-1,8A4.5,4.5,0,1,1,12,7.5,4.505,4.505,0,0,1,16.5,12Z', 'M11.646,14.353a.5.5,0,0,0,.708,0l1.5-1.5A.5.5,0,0,0,13.5,12h-.75a.25.25,0,0,1-.25-.25V10a.5.5,0,0,0-1,0v1.75a.25.25,0,0,1-.25.25H10.5a.5.5,0,0,0-.354.853Z']],
  SmartWatchSquare: ['smart-watch-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Z']],
  SmartWatchSquareCash: ['smart-watch-square-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM10.625,15.75a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.22-1.141l-2.063-.826a2.091,2.091,0,0,1,.36-3.991.25.25,0,0,0,.2-.245v-.3a.75.75,0,0,1,1.5,0V8a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5H11.592a.592.592,0,0,0-.22,1.141l2.063.825a2.092,2.092,0,0,1-.36,3.992.25.25,0,0,0-.2.245v.3a.75.75,0,0,1-1.5,0V16a.25.25,0,0,0-.25-.25Z']],
  SmartWatchSquareEmail: ['smart-watch-square-email', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-1.521,6.412-3.734,2.215a.488.488,0,0,1-.49,0L8.022,10.413A.042.042,0,0,1,8,10.376.9.9,0,0,1,8.923,9.5h6.154a.9.9,0,0,1,.923.876A.042.042,0,0,1,15.979,10.412ZM16,11.636v2.935a.927.927,0,0,1-.923.929H8.923A.927.927,0,0,1,8,14.571V11.636a.155.155,0,0,1,.079-.136.153.153,0,0,1,.156,0l3.031,1.907a1.388,1.388,0,0,0,1.468,0L15.765,11.5a.151.151,0,0,1,.156,0A.154.154,0,0,1,16,11.636Z']],
  SmartWatchSquareFlash: ['smart-watch-square-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM9.25,13a.751.751,0,0,1-.57-1.238l3.941-4.588A.5.5,0,0,1,13.5,7.5v3.25a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,.57,1.237l-3.941,4.588A.5.5,0,0,1,10.5,16.5V13.25a.25.25,0,0,0-.25-.25Z']],
  SmartWatchSquarePlay: ['smart-watch-square-play', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-2.28,7.285a1.113,1.113,0,0,1,0,1.929l-4.5,2.629a1.157,1.157,0,0,1-1.136.014A1.122,1.122,0,0,1,9,14.879V9.621a1.122,1.122,0,0,1,.581-.978,1.154,1.154,0,0,1,1.138.014Z']],
  SmartWatchSquareNavigation: ['smart-watch-square-navigation', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM15.955,8.428,12.42,16.207a.5.5,0,0,1-.953-.162l-.3-3.266a.25.25,0,0,0-.226-.227l-3.267-.3a.5.5,0,0,1-.162-.953l7.778-3.536a.5.5,0,0,1,.662.662Z']],
  SmartWatchSquareRinging: ['smart-watch-square-ringing', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-6.263,8.021a.25.25,0,0,0-.237.25V14a1.58,1.58,0,0,1-1.5,1.5h-1A1.58,1.58,0,0,1,7,14V13c0-1.474,2.583-2,5-2s5,.525,5,2v1a1.58,1.58,0,0,1-1.5,1.5h-1A1.627,1.627,0,0,1,13,14V12.271a.249.249,0,0,0-.237-.249A14.94,14.94,0,0,0,11.237,12.021ZM8.667,8.227a.5.5,0,0,1,.662.246l.625,1.363a.5.5,0,1,1-.908.417L8.421,8.89A.5.5,0,0,1,8.667,8.227ZM11.5,9.5V8a.5.5,0,0,1,1,0V9.5a.5.5,0,0,1-1,0Zm2.546.336.625-1.363a.5.5,0,1,1,.908.417l-.625,1.363a.5.5,0,1,1-.908-.417Z']],
  SmartWatchCircleBrightnessAlternate: ['smart-watch-circle-brightness-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M10.000 12.252 A2.000 2.000 0 1 0 14.000 12.252 A2.000 2.000 0 1 0 10.000 12.252 Z', 'M13.250 8.002 A1.000 1.000 0 1 0 15.250 8.002 A1.000 1.000 0 1 0 13.250 8.002 Z', 'M8.750 8.002 A1.000 1.000 0 1 0 10.750 8.002 A1.000 1.000 0 1 0 8.750 8.002 Z', 'M13.250 16.002 A1.000 1.000 0 1 0 15.250 16.002 A1.000 1.000 0 1 0 13.250 16.002 Z', 'M15.750 12.002 A1.000 1.000 0 1 0 17.750 12.002 A1.000 1.000 0 1 0 15.750 12.002 Z', 'M6.250 12.002 A1.000 1.000 0 1 0 8.250 12.002 A1.000 1.000 0 1 0 6.250 12.002 Z', 'M8.750 16.002 A1.000 1.000 0 1 0 10.750 16.002 A1.000 1.000 0 1 0 8.750 16.002 Z']],
  SmartWatchCirclePowerAlternate: ['smart-watch-circle-power-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M11.25,7.5V10.93a.75.75,0,0,0,1.5,0V7.5a.75.75,0,1,0-1.5,0Z', 'M14.3,8.643a.749.749,0,0,0,0,1.06,3.25,3.25,0,1,1-4.6,0,.75.75,0,0,0-1.061-1.06,4.751,4.751,0,1,0,6.717,0A.749.749,0,0,0,14.3,8.643Z']],
  SmartWatchCircleAlternate: ['smart-watch-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.25.25,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.369l.935-3.427a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12Zm-8.031,7.359a7.5,7.5,0,1,1,5.89-5.89A7.515,7.515,0,0,1,13.469,19.361Z']],
  SmartWatchCircleFlashAlternate: ['smart-watch-circle-flash-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M14.75,11h-1a.25.25,0,0,1-.25-.25V7.5a.5.5,0,0,0-.879-.326L8.679,11.764A.751.751,0,0,0,9.25,13h1a.25.25,0,0,1,.25.25V16.5a.5.5,0,0,0,.326.468.5.5,0,0,0,.553-.143l3.941-4.588A.751.751,0,0,0,14.75,11Z']],
  SmartWatchCircleDumbbellAlternate: ['smart-watch-circle-dumbbell-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M17.5,11.252h-.75A.25.25,0,0,1,16.5,11v-.5A1.5,1.5,0,0,0,15,9H13.5a.5.5,0,0,0-.5.5V11a.25.25,0,0,1-.25.25h-1.5A.25.25,0,0,1,11,11V9.5a.5.5,0,0,0-.5-.5H9a1.5,1.5,0,0,0-1.5,1.5V11a.25.25,0,0,1-.25.25H6.5a.75.75,0,0,0,0,1.5h.75A.25.25,0,0,1,7.5,13v.5A1.5,1.5,0,0,0,9,15h1.5a.5.5,0,0,0,.5-.5V13a.25.25,0,0,1,.25-.25h1.5A.25.25,0,0,1,13,13v1.5a.5.5,0,0,0,.5.5H15a1.5,1.5,0,0,0,1.5-1.5V13a.25.25,0,0,1,.25-.25h.75a.75.75,0,0,0,0-1.5Z']],
  SmartWatchCircleGraphLineAlternate: ['smart-watch-circle-graph-line-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5a7.512,7.512,0,0,1-7.338-5.948.25.25,0,0,1,.244-.3H6.5a.752.752,0,0,0,.648-.373L9.07,9.572a.25.25,0,0,1,.453.043L11.386,15a1.249,1.249,0,0,0,2.289.016l1.216-2.956a.25.25,0,0,1,.446-.033l.519.865a.75.75,0,0,0,.644.365h2.593a.25.25,0,0,1,.245.3A7.513,7.513,0,0,1,12,19.5Zm0-15a7.508,7.508,0,0,1,7.481,6.982.25.25,0,0,1-.249.268H17.066a.248.248,0,0,1-.214-.122l-.74-1.232a1.249,1.249,0,0,0-2.213.133l-1.092,2.653a.25.25,0,0,1-.467-.013L10.552,8.01a1.249,1.249,0,0,0-1.035-.753,1.274,1.274,0,0,0-1.178.59l-2.2,3.78a.25.25,0,0,1-.216.125H4.767a.251.251,0,0,1-.183-.08.248.248,0,0,1-.066-.188A7.508,7.508,0,0,1,12,4.5Z']],
  SmartWatchCircleMusicAlternate: ['smart-watch-circle-music-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.25.25,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M15.4,7.526a1.725,1.725,0,0,0-1.525-.256l-3.3.848a1.749,1.749,0,0,0-1.2,1.661v3.029a.25.25,0,0,1-.25.25h0a1.75,1.75,0,1,0,1.75,1.75V9.779A.255.255,0,0,1,11,9.556l3.3-.848a.251.251,0,0,1,.329.238v2.362a.25.25,0,0,1-.25.25h0a1.75,1.75,0,1,0,1.75,1.75V8.946A1.755,1.755,0,0,0,15.4,7.526Z']],
  SmartWatchCircleMicrophoneAlternate: ['smart-watch-circle-microphone-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.245.245,0,0,1-.109-.148L15.983.374A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.78A.245.245,0,0,1,7,3.928,9.5,9.5,0,0,0,7,20.077a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M12,7a2,2,0,0,0-2,2v2a2,2,0,0,0,4,0V9A2,2,0,0,0,12,7Z', 'M15.5,10.753a.75.75,0,0,0-.75.75,2.75,2.75,0,0,1-5.5,0,.75.75,0,0,0-1.5,0,4.258,4.258,0,0,0,3.305,4.144.25.25,0,0,1,.2.243V17a.75.75,0,0,0,1.5,0V15.89a.249.249,0,0,1,.194-.243A4.258,4.258,0,0,0,16.25,11.5.75.75,0,0,0,15.5,10.753Z']],
  SmartWatchCircleMissedCallAlternate: ['smart-watch-circle-missed-call-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.247.247,0,0,1,.109.148l.908,3.406A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.369l.935-3.427a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M13.945,13.709a1.529,1.529,0,0,0-1.085-.449h0a1.52,1.52,0,0,0-1.081.45l-.8.8a.249.249,0,0,1-.345.008c-.4-.364-.783-.748-1.147-1.147a.25.25,0,0,1,.008-.346l.8-.8a1.532,1.532,0,0,0,0-2.166l-.832-.833a1.536,1.536,0,0,0-2.17,0l-.455.456A1.932,1.932,0,0,0,6.593,12.1a18.962,18.962,0,0,0,5.305,5.3,1.934,1.934,0,0,0,2.422-.244l.455-.455a1.534,1.534,0,0,0,0-2.169Z', 'M15.445,7.5l-1.47,1.469a.249.249,0,0,1-.354,0l-.292-.293a.5.5,0,0,0-.854.354v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.354-.854l-.293-.293a.247.247,0,0,1,0-.353l1.469-1.47a.75.75,0,0,0-1.06-1.06Z']],
  SmartWatchCircleStarAlternate: ['smart-watch-circle-star-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M15.492,10H14.01a.251.251,0,0,1-.234-.162l-.844-2.229a.431.431,0,0,0-.022-.049,1.054,1.054,0,0,0-1.857.049L10.208,9.84A.251.251,0,0,1,9.974,10H8.492a.986.986,0,0,0-.934.611,1.03,1.03,0,0,0,.3,1.154l1.232.859a.251.251,0,0,1,.087.3l-.717,1.645a1,1,0,0,0,.251,1.158,1.022,1.022,0,0,0,1.2.133l1.956-1.1a.254.254,0,0,1,.245,0l1.957,1.1a1.027,1.027,0,0,0,1.2-.133,1,1,0,0,0,.251-1.158L14.8,12.93a.25.25,0,0,1,.085-.3l1.3-.912a1,1,0,0,0,.238-1.1A.984.984,0,0,0,15.492,10Z']],
  SmartWatchCircleSleepAlternate: ['smart-watch-circle-sleep-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M14.812,7.776A1.5,1.5,0,0,0,13.5,7H9.9a1,1,0,1,0,0,2h2.244a.25.25,0,0,1,.212.382L9.03,14.71A1.5,1.5,0,0,0,10.3,17h3.6a1,1,0,1,0,0-2H11.657a.25.25,0,0,1-.212-.383L14.771,9.3A1.5,1.5,0,0,0,14.812,7.776Z']],
  SmartWatchSquareApp: ['smart-watch-square-app', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.248.248,0,0,0,.2-.1.251.251,0,0,0,.035-.225L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.035.225.248.248,0,0,0,.2.1Z', 'M7.57,21.25a.251.251,0,0,0-.238.329l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.238-.329Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM9.75,7a1,1,0,1,1-1,1A1,1,0,0,1,9.75,7Zm-2.5,6a1,1,0,1,1,1-1A1,1,0,0,1,7.25,13Zm2.5,4a1,1,0,1,1,1-1A1,1,0,0,1,9.75,17ZM10,12.25a2,2,0,1,1,2,2A2,2,0,0,1,10,12.25ZM14.25,17a1,1,0,1,1,1-1A1,1,0,0,1,14.25,17Zm0-8a1,1,0,1,1,1-1A1,1,0,0,1,14.25,9Zm2.5,4a1,1,0,1,1,1-1A1,1,0,0,1,16.75,13Z']],
  SmartWatchCircleTextAlternate: ['smart-watch-circle-text-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M16.667,9.5a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v4a1.5,1.5,0,0,0,1.5,1.5h.25a.25.25,0,0,1,.25.25V16.5a.5.5,0,0,0,.812.39l2.3-1.836A.25.25,0,0,1,12.93,15h2.237a1.5,1.5,0,0,0,1.5-1.5Zm-6.5,3.5a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Zm0-2.25a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z']],
  SmartWatchCircleWifiAlternate: ['smart-watch-circle-wifi-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M11.000 15.002 A1.000 1.000 0 1 0 13.000 15.002 A1.000 1.000 0 1 0 11.000 15.002 Z', 'M16.47,9.634a7.067,7.067,0,0,0-8.941,0A.75.75,0,1,0,8.47,10.8a5.581,5.581,0,0,1,7.059,0,.75.75,0,1,0,.941-1.167Z', 'M14.8,12.044a4.431,4.431,0,0,0-5.607,0,.75.75,0,1,0,.941,1.167,2.945,2.945,0,0,1,3.725,0,.75.75,0,1,0,.941-1.167Z']],
  SmartWatchSquareAlternate: ['smart-watch-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z']],
  SmartWatchCircleTemperatureAlternate: ['smart-watch-circle-temperature-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M8.000 9.002 A1.500 1.500 0 1 0 11.000 9.002 A1.500 1.500 0 1 0 8.000 9.002 Z', 'M15,11.252a.75.75,0,0,0,0-1.5,3.75,3.75,0,0,0,0,7.5.75.75,0,0,0,0-1.5,2.25,2.25,0,0,1,0-4.5Z']],
  SmartWatchSquareAppAlternate: ['smart-watch-square-app-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.25.25,0,0,1-.24-.181L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.456A.249.249,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.248.248,0,0,1,.24.182l.7,2.455A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.455a.249.249,0,0,1,.24-.182H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M10.000 12.252 A2.000 2.000 0 1 0 14.000 12.252 A2.000 2.000 0 1 0 10.000 12.252 Z', 'M13.250 8.002 A1.000 1.000 0 1 0 15.250 8.002 A1.000 1.000 0 1 0 13.250 8.002 Z', 'M8.750 8.002 A1.000 1.000 0 1 0 10.750 8.002 A1.000 1.000 0 1 0 8.750 8.002 Z', 'M13.250 16.002 A1.000 1.000 0 1 0 15.250 16.002 A1.000 1.000 0 1 0 13.250 16.002 Z', 'M15.750 12.002 A1.000 1.000 0 1 0 17.750 12.002 A1.000 1.000 0 1 0 15.750 12.002 Z', 'M6.250 12.002 A1.000 1.000 0 1 0 8.250 12.002 A1.000 1.000 0 1 0 6.250 12.002 Z', 'M8.750 16.002 A1.000 1.000 0 1 0 10.750 16.002 A1.000 1.000 0 1 0 8.750 16.002 Z']],
  SmartWatchSquareGraphAlternate: ['smart-watch-square-graph-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M17,13.752H16a.25.25,0,0,1-.25-.25v-2.25a.75.75,0,0,0-1.5,0V13.5a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25V9.627a.75.75,0,0,0-1.5,0V13.5a.25.25,0,0,1-.25.25H10a.25.25,0,0,1-.25-.25V8a.75.75,0,1,0-1.5,0v5.5a.25.25,0,0,1-.25.25H7a.75.75,0,0,0,0,1.5H17a.75.75,0,0,0,0-1.5Z']],
  SmartWatchSquareGraphLineAlternate: ['smart-watch-square-graph-line-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM5,6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1v5a.25.25,0,0,1-.25.25H17.066a.248.248,0,0,1-.214-.122L16.112,9.9a1.249,1.249,0,0,0-2.213.133l-1.092,2.653a.25.25,0,0,1-.467-.013L10.552,7.51a1.249,1.249,0,0,0-1.035-.753,1.27,1.27,0,0,0-1.178.59l-2.2,3.78a.25.25,0,0,1-.216.125H5.25A.25.25,0,0,1,5,11ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V13a.25.25,0,0,1,.25-.25H6.5a.752.752,0,0,0,.648-.373L9.07,9.072a.25.25,0,0,1,.453.043l1.863,5.38a1.256,1.256,0,0,0,1.114.756h.034a1.272,1.272,0,0,0,1.141-.741l1.216-2.956a.25.25,0,0,1,.446-.033l.519.865a.75.75,0,0,0,.644.365h2.25A.25.25,0,0,1,19,13Z']],
  SmartWatchSquareEmailAlternate: ['smart-watch-square-email-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M16.574,10.835a.177.177,0,0,0-.182,0l-3.536,2.224a1.612,1.612,0,0,1-1.712,0L7.608,10.84a.18.18,0,0,0-.275.153v3.425A1.082,1.082,0,0,0,8.41,15.5h7.179a1.082,1.082,0,0,0,1.077-1.084V10.993A.18.18,0,0,0,16.574,10.835Z', 'M15.589,8.5H8.41A1.051,1.051,0,0,0,7.333,9.524a.053.053,0,0,0,.025.043l4.356,2.583a.566.566,0,0,0,.571,0l4.356-2.584a.048.048,0,0,0,.025-.042A1.051,1.051,0,0,0,15.589,8.5Z']],
  SmartWatchSquareFlashAlternate: ['smart-watch-square-flash-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3V6A3,3,0,0,0,18,3Zm1,15a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M14.75,11h-1a.25.25,0,0,1-.25-.25V7.5a.5.5,0,0,0-.879-.326L8.679,11.764A.751.751,0,0,0,9.25,13h1a.25.25,0,0,1,.25.25V16.5a.5.5,0,0,0,.326.468.5.5,0,0,0,.553-.143l3.941-4.588A.751.751,0,0,0,14.75,11Z']],
  SmartWatchSquareLocationAlternate: ['smart-watch-square-location-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,7.5A3.5,3.5,0,0,0,8.5,11c0,1.319,1.474,3.483,2.711,5.065a.991.991,0,0,0,.789.385,1.008,1.008,0,0,0,.787-.383C14.024,14.487,15.5,12.324,15.5,11A3.5,3.5,0,0,0,12,7.5ZM12,10a1,1,0,1,1-1,1A1,1,0,0,1,12,10Z']],
  SmartWatchSquareMicrophoneAlternate: ['smart-watch-square-microphone-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,13a2,2,0,0,0,2-2V9a2,2,0,1,0-4,0v2A2,2,0,0,0,12,13Z', 'M15.5,10.752a.75.75,0,0,0-.75.75,2.75,2.75,0,1,1-5.5,0,.75.75,0,0,0-1.5,0,4.258,4.258,0,0,0,3.305,4.144.25.25,0,0,1,.2.243V17a.75.75,0,0,0,1.5,0V15.889a.249.249,0,0,1,.194-.243A4.258,4.258,0,0,0,16.25,11.5.75.75,0,0,0,15.5,10.752Z']],
  SmartWatchSquareMissedCallAlternate: ['smart-watch-square-missed-call-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.364A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.362l-.7,2.456A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M14.444,13.234a1.57,1.57,0,0,0-2.167,0l-.8.8a.249.249,0,0,1-.345.007q-.6-.546-1.147-1.147a.249.249,0,0,1,.008-.345l.8-.8a1.533,1.533,0,0,0,0-2.167l-.832-.833a1.538,1.538,0,0,0-2.17,0l-.455.456a1.932,1.932,0,0,0-.244,2.421,18.936,18.936,0,0,0,5.305,5.3,1.933,1.933,0,0,0,2.422-.244l.455-.455a1.533,1.533,0,0,0,0-2.168Z', 'M17.005,7.022a.749.749,0,0,0-1.06,0l-1.47,1.47a.251.251,0,0,1-.354,0L13.829,8.2a.5.5,0,0,0-.854.353v2a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.354-.853l-.293-.293a.249.249,0,0,1,0-.354l1.469-1.469A.75.75,0,0,0,17.005,7.022Z']],
  SmartWatchSquareHouseAlternate: ['smart-watch-square-house-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M17.129,11.414l-4.91-3.833a.343.343,0,0,0-.439,0L6.87,11.414a.329.329,0,0,0-.1.369A.341.341,0,0,0,7.089,12H8a.25.25,0,0,1,.25.25V15.5a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-1.25a1.25,1.25,0,0,1,2.5,0V15.5a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-3.25A.25.25,0,0,1,16,12h.91a.34.34,0,0,0,.319-.219A.329.329,0,0,0,17.129,11.414Z']],
  SmartWatchSquarePowerAlternate: ['smart-watch-square-power-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,11.68a.75.75,0,0,0,.75-.75V7.5a.75.75,0,1,0-1.5,0V10.93A.75.75,0,0,0,12,11.68Z', 'M14.3,8.643a.749.749,0,0,0,0,1.06,3.25,3.25,0,1,1-4.6,0,.75.75,0,0,0-1.061-1.06,4.751,4.751,0,1,0,6.717,0A.75.75,0,0,0,14.3,8.643Z']],
  SmartWatchSquareNavigationAlternate: ['smart-watch-square-navigation-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.955,8.209a.5.5,0,0,0-.662-.662L7.514,11.082a.5.5,0,0,0,.162.953l3.267.3a.251.251,0,0,1,.227.227l.3,3.266a.5.5,0,0,0,.954.162Z']],
  SmartWatchSquarePlayAlternate: ['smart-watch-square-play-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15,11.239l-4.5-2.63A1.159,1.159,0,0,0,9.36,8.6a1.121,1.121,0,0,0-.583.978v5.258a1.121,1.121,0,0,0,.583.979A1.159,1.159,0,0,0,10.5,15.8l4.5-2.63a1.112,1.112,0,0,0,0-1.927Z']],
  SmartWatchSquareStarAlternate: ['smart-watch-square-star-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.506,10.5H14.024a.251.251,0,0,1-.234-.162l-.844-2.229a.437.437,0,0,0-.023-.049,1.053,1.053,0,0,0-1.855.049l-.845,2.229a.251.251,0,0,1-.234.162H8.506a.986.986,0,0,0-.933.611,1.029,1.029,0,0,0,.3,1.154l1.231.859a.249.249,0,0,1,.086.3l-.716,1.645a1,1,0,0,0,.251,1.158,1.027,1.027,0,0,0,1.2.133l1.958-1.1a.254.254,0,0,1,.245,0l1.957,1.1a1.017,1.017,0,0,0,1.2-.132,1,1,0,0,0,.251-1.158l-.718-1.646a.252.252,0,0,1,.086-.3l1.3-.912a1.006,1.006,0,0,0,.238-1.1A.986.986,0,0,0,15.506,10.5Z']],
  SmartWatchSquareSleepAlternate: ['smart-watch-square-sleep-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.007,7.776A1.5,1.5,0,0,0,13.7,7H10.1a1,1,0,0,0,0,2h2.245a.249.249,0,0,1,.219.129.247.247,0,0,1-.007.253L9.228,14.706A1.5,1.5,0,0,0,10.5,17h3.6a1,1,0,1,0,0-2H11.853a.25.25,0,0,1-.212-.383l3.328-5.325A1.5,1.5,0,0,0,15.007,7.776Z']],
  SmartWatchSquareTemperatureAlternate: ['smart-watch-square-temperature-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M8.000 8.952 A1.500 1.500 0 1 0 11.000 8.952 A1.500 1.500 0 1 0 8.000 8.952 Z', 'M15,11.2a.75.75,0,0,0,0-1.5,3.75,3.75,0,0,0,0,7.5.75.75,0,1,0,0-1.5,2.25,2.25,0,0,1,0-4.5Z']],
  SmartWatchWristAlternate: ['smart-watch-wrist-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.971,17.58,23.155,12.4A3.977,3.977,0,0,0,19.2,9H15.47a6.007,6.007,0,0,0-2.977.79L10.376,11H9.349a.25.25,0,0,1-.236-.167.5.5,0,0,0-.472-.333h-4a.5.5,0,0,0-.471.333A.25.25,0,0,1,3.934,11H1a1,1,0,1,0,0,2h2.06a.249.249,0,0,1,.225.357A1.49,1.49,0,0,0,3.141,14v4a1.485,1.485,0,0,0,.145.642A.25.25,0,0,1,3.061,19H1a1,1,0,0,0,0,2H3.934a.25.25,0,0,1,.236.167.5.5,0,0,0,.471.333h4a.5.5,0,0,0,.472-.333A.25.25,0,0,1,9.349,21h.824l.7.841A5.982,5.982,0,0,0,15.483,24h1.8a3,3,0,0,0,2.991-2.769A.251.251,0,0,1,20.523,21H21a3,3,0,0,0,2.97-3.418Zm-18.33.387a.751.751,0,0,1-.75-.75v-2.5a.752.752,0,0,1,.75-.75h2a.751.751,0,0,1,.75.75v2.5a.75.75,0,0,1-.75.75ZM21,19H16.283a1,1,0,0,0,0,2h1.706a.25.25,0,0,1,.236.334,1.012,1.012,0,0,1-.236.373.987.987,0,0,1-.706.293h-1.8a3.99,3.99,0,0,1-3.072-1.439l-1-1.2a1,1,0,0,0-.769-.36h-.419A.251.251,0,0,1,10,18.641,1.49,1.49,0,0,0,10.141,18V14A1.5,1.5,0,0,0,10,13.355.249.249,0,0,1,10.222,13h.419a1.01,1.01,0,0,0,.5-.132l2.347-1.341A4,4,0,0,1,15.47,11H19.2a1.992,1.992,0,0,1,1.98,1.711l.813,5.159A1,1,0,0,1,21,19Z', 'M5.108,7.277A1,1,0,1,0,6.493,8.719a.751.751,0,0,1,1.016,0A1,1,0,1,0,8.893,7.277,2.759,2.759,0,0,0,5.108,7.277Z', 'M11.321,6.384a1,1,0,0,0-.028-1.414,6.255,6.255,0,0,0-8.584,0A1,1,0,0,0,4.094,6.413a4.236,4.236,0,0,1,5.814,0A1,1,0,0,0,11.321,6.384Z', 'M1.694,4.107a7.73,7.73,0,0,1,10.613,0,1,1,0,1,0,1.387-1.442,9.753,9.753,0,0,0-13.387,0A1,1,0,0,0,1.694,4.107Z']],
  SmartWatchSquareTimeAlternate: ['smart-watch-square-time-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,2.5H16.874a.25.25,0,0,1-.237-.171L15.974.344A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.363,2.331a.251.251,0,0,1-.238.171H5.5a3,3,0,0,0-3,3v13a3,3,0,0,0,3,3H7.125a.251.251,0,0,1,.238.171l.662,1.987A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.474-.342l.663-1.987a.25.25,0,0,1,.237-.171H18.5a3,3,0,0,0,3-3V5.5A3,3,0,0,0,18.5,2.5Zm1,16a1,1,0,0,1-1,1H5.5a1,1,0,0,1-1-1V5.5a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1Z', 'M16.729,7.877c-1.647,0-1.647,1.905-1.647,2.623s0,2.627,1.647,2.627,1.646-1.908,1.646-2.627S18.375,7.877,16.729,7.877Zm0,4c-.129,0-.4,0-.4-1.377s.268-1.373.4-1.373.4,0,.4,1.373S16.847,11.877,16.729,11.877Z', 'M7.153,11.877a.625.625,0,0,0,0,1.25,2.1,2.1,0,0,0,2.136-2.334V9.7A1.652,1.652,0,1,0,6,9.7,1.625,1.625,0,0,0,7.64,11.482a.127.127,0,0,1,.12.085.125.125,0,0,1-.039.141A.86.86,0,0,1,7.153,11.877Zm.487-1.645c-.138,0-.395,0-.395-.531s.248-.533.395-.533.4,0,.4.533S7.78,10.232,7.64,10.232Z', 'M9.958 9.502 A0.500 0.500 0 1 0 10.958 9.502 A0.500 0.500 0 1 0 9.958 9.502 Z', 'M9.958 11.502 A0.500 0.500 0 1 0 10.958 11.502 A0.500 0.500 0 1 0 9.958 11.502 Z', 'M16.914,15h-9.5a.75.75,0,1,0,0,1.5h9.5a.75.75,0,0,0,0-1.5Z', 'M12.164,11.617h.854a.25.25,0,0,1,.25.25v.551a.625.625,0,0,0,1.25,0v-.754a.249.249,0,0,1,.09-.192.625.625,0,0,0,0-.959.251.251,0,0,1-.09-.192V8.5a.625.625,0,0,0-.625-.625h-.729A1.626,1.626,0,0,0,11.539,9.5v1.49A.625.625,0,0,0,12.164,11.617ZM12.789,9.5a.375.375,0,0,1,.375-.375.1.1,0,0,1,.1.1v.9a.24.24,0,0,1-.479,0Z']],
  SmartWatchSquareWifiAlternate: ['smart-watch-square-wifi-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M11.000 15.002 A1.000 1.000 0 1 0 13.000 15.002 A1.000 1.000 0 1 0 11.000 15.002 Z', 'M16.47,9.634a7.067,7.067,0,0,0-8.941,0A.75.75,0,1,0,8.47,10.8a5.581,5.581,0,0,1,7.059,0,.75.75,0,1,0,.941-1.167Z', 'M14.8,12.044a4.431,4.431,0,0,0-5.607,0,.75.75,0,1,0,.941,1.167,2.945,2.945,0,0,1,3.725,0,.75.75,0,1,0,.941-1.167Z']],
  SmartWatchCircleCash: ['smart-watch-circle-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm.909,12.458a.25.25,0,0,0-.2.245v.3a.75.75,0,0,1-1.5,0v-.25a.25.25,0,0,0-.25-.25h-.5a.75.75,0,1,1,0-1.5h2.034a.592.592,0,0,0,.219-1.141l-2.062-.826a2.091,2.091,0,0,1,.359-3.991.25.25,0,0,0,.2-.245V8a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5H11.425a.592.592,0,0,0-.22,1.141l2.063.825a2.092,2.092,0,0,1-.359,3.992Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleDumbbell: ['smart-watch-circle-dumbbell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm5.583,9.75h-1V14a1.5,1.5,0,0,1-1.5,1.5h-1.5a.5.5,0,0,1-.5-.5V13.5a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25V15a.5.5,0,0,1-.5.5h-1.5a1.5,1.5,0,0,1-1.5-1.5v-.75h-1a.75.75,0,1,1,0-1.5h1V11a1.5,1.5,0,0,1,1.5-1.5h1.5a.5.5,0,0,1,.5.5v1.5a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25V10a.5.5,0,0,1,.5-.5h1.5a1.5,1.5,0,0,1,1.5,1.5v.75h1a.75.75,0,0,1,0,1.5Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleFlash: ['smart-watch-circle-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm3.4,8.737-3.942,4.588a.5.5,0,0,1-.879-.325V13.25a.25.25,0,0,0-.25-.25h-1a.751.751,0,0,1-.57-1.238L12.7,7.174a.5.5,0,0,1,.879.326v3.25a.25.25,0,0,0,.25.25h1a.751.751,0,0,1,.571,1.237Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleBrightness: ['smart-watch-circle-brightness', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5ZM9.865,7a1,1,0,1,1-1,1A1,1,0,0,1,9.865,7Zm-2.5,6a1,1,0,1,1,1-1A1,1,0,0,1,7.365,13Zm2.5,4a1,1,0,1,1,1-1A1,1,0,0,1,9.865,17Zm.25-4.75a2,2,0,1,1,2,2A2,2,0,0,1,10.115,12.25ZM14.365,17a1,1,0,1,1,1-1A1,1,0,0,1,14.365,17Zm0-8a1,1,0,1,1,1-1A1,1,0,0,1,14.365,9Zm2.5,4a1,1,0,1,1,1-1A1,1,0,0,1,16.865,13Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleHeart: ['smart-watch-circle-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm4.14,8.931-3.96,4.13a.249.249,0,0,1-.36,0l-3.959-4.13a2.449,2.449,0,1,1,3.463-3.463l.5.5a.252.252,0,0,0,.354,0l.5-.5a2.449,2.449,0,0,1,3.464,3.463Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleHome: ['smart-watch-circle-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm5.229,8.281A.34.34,0,0,1,16.91,12H16a.25.25,0,0,0-.25.25V15.5a.5.5,0,0,1-.5.5h-1.5a.5.5,0,0,1-.5-.5V14.25a1.25,1.25,0,0,0-2.5,0V15.5a.5.5,0,0,1-.5.5H8.75a.5.5,0,0,1-.5-.5V12.25A.25.25,0,0,0,8,12H7.089a.339.339,0,0,1-.318-.219.329.329,0,0,1,.1-.369l4.911-3.833a.341.341,0,0,1,.438,0l4.911,3.833A.33.33,0,0,1,17.229,11.781Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleMissedCall: ['smart-watch-circle-missed-call', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm2.125,12.754-.456.455a1.681,1.681,0,0,1-2.107.213,18.7,18.7,0,0,1-5.234-5.233,1.682,1.682,0,0,1,.21-2.106L7,9.126a1.289,1.289,0,0,1,1.817,0l.83.833a1.282,1.282,0,0,1,0,1.813l-.973.971a.249.249,0,0,0-.01.342,17.543,17.543,0,0,0,1.506,1.506.248.248,0,0,0,.342-.01l.971-.971a1.272,1.272,0,0,1,.905-.376h0a1.274,1.274,0,0,1,.908.376l.83.831A1.285,1.285,0,0,1,14.125,16.254ZM15.854,8.1l-1.47,1.47a.25.25,0,0,0,0,.354l.47.469a.5.5,0,0,1-.354.854h-2a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.854-.354l.469.47a.25.25,0,0,0,.354,0L15.146,7.4a.5.5,0,1,1,.708.707Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.663,21.078a.125.125,0,0,0-.177-.144,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371Z']],
  SmartWatchCircleMusic: ['smart-watch-circle-music', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm3.75,9.363A1.75,1.75,0,1,1,14,11.113a.252.252,0,0,0,.177-.074.248.248,0,0,0,.073-.176V8.5a.251.251,0,0,0-.329-.238l-3.3.849a.252.252,0,0,0-.12.222v5.03a1.75,1.75,0,1,1-1.75-1.75.252.252,0,0,0,.177-.074A.248.248,0,0,0,9,12.363V9.333a1.747,1.747,0,0,1,1.2-1.66l3.3-.849a1.727,1.727,0,0,1,1.526.256A1.753,1.753,0,0,1,15.75,8.5Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleNavigation: ['smart-watch-circle-navigation', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm3.733,5.428L12.2,16.707a.5.5,0,0,1-.953-.162l-.3-3.266a.251.251,0,0,0-.227-.227l-3.266-.3a.5.5,0,0,1-.162-.953l7.778-3.536a.5.5,0,0,1,.662.662Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleMail: ['smart-watch-circle-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm4.083,10.571A.927.927,0,0,1,15.16,15H9.006a.927.927,0,0,1-.923-.929V11.136A.156.156,0,0,1,8.163,11a.153.153,0,0,1,.156,0l3.031,1.907a1.386,1.386,0,0,0,1.467,0L15.848,11A.151.151,0,0,1,16,11a.154.154,0,0,1,.079.136Zm-.021-4.159-3.734,2.215a.486.486,0,0,1-.489,0L8.105,9.913a.042.042,0,0,1-.022-.037A.9.9,0,0,1,9.006,9H15.16a.9.9,0,0,1,.923.876A.042.042,0,0,1,16.062,9.912Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleRinging: ['smart-watch-circle-ringing', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm2.129,6.336.625-1.363a.5.5,0,1,1,.908.417l-.625,1.363a.5.5,0,1,1-.908-.417ZM11.583,8a.5.5,0,1,1,1,0V9.5a.5.5,0,0,1-1,0ZM8.75,8.227a.5.5,0,0,1,.662.246l.625,1.363a.5.5,0,1,1-.908.417L8.5,8.89A.5.5,0,0,1,8.75,8.227ZM17.085,14a1.579,1.579,0,0,1-1.5,1.5c-1.213,0-.97,0-1.03,0A1.589,1.589,0,0,1,13.083,14V12.27a.25.25,0,0,0-.235-.25c-.4-.023-1.124-.024-1.53,0a.25.25,0,0,0-.235.25V14a1.579,1.579,0,0,1-1.5,1.5h-1a1.58,1.58,0,0,1-1.5-1.5V13c0-.723.686-2,5-2,.629,0,5,.058,5,2Z', 'M7.337,2.922a.124.124,0,0,0,.177.143,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371Z', 'M16.663,21.078a.125.125,0,0,0-.177-.144,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371Z']],
  SmartWatchCircleSleep: ['smart-watch-circle-sleep', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm1.986,11.75a.75.75,0,0,1,0,1.5h-3.6a1.251,1.251,0,0,1-1.062-1.911l3.567-5.707a.25.25,0,0,0-.212-.382H9.986a.75.75,0,0,1,0-1.5h3.6a1.25,1.25,0,0,1,1.06,1.913l-3.566,5.7a.251.251,0,0,0,.212.383Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleSound: ['smart-watch-circle-sound', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5ZM12.583,15a.5.5,0,0,1-.5.5h-.5A3.5,3.5,0,0,1,8.5,13.633.25.25,0,0,0,8.28,13.5h-1.2a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,.5-.5h1.2a.252.252,0,0,0,.221-.134A3.5,3.5,0,0,1,11.583,8.5h.5a.5.5,0,0,1,.5.5Zm1.361-.278a.5.5,0,0,1-.075-.7,3.2,3.2,0,0,0,0-4.039.5.5,0,0,1,.778-.628,4.184,4.184,0,0,1,0,5.3A.5.5,0,0,1,13.944,14.722Zm2.113,1.592a.5.5,0,1,1-.777-.628,5.83,5.83,0,0,0,0-7.372.5.5,0,1,1,.777-.628A6.821,6.821,0,0,1,16.057,16.314Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.663,21.078a.125.125,0,0,0-.177-.144,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371Z']],
  SmartWatchCirclePower: ['smart-watch-circle-power', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm-.667,4a.75.75,0,1,1,1.5,0v3.428a.75.75,0,0,1-1.5,0Zm.75,9.25A4.75,4.75,0,0,1,8.725,8.641.75.75,0,0,1,9.785,9.7a3.25,3.25,0,1,0,4.6,0,.75.75,0,1,1,1.061-1.06,4.75,4.75,0,0,1-3.359,8.109Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleTemperature: ['smart-watch-circle-temperature', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5ZM9.583,10a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,9.583,10Zm5.5,5.25a.75.75,0,0,1,0,1.5,3.75,3.75,0,1,1,0-7.5.75.75,0,0,1,0,1.5,2.25,2.25,0,1,0,0,4.5Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleText: ['smart-watch-circle-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm4.5,10.416a1.5,1.5,0,0,1-1.5,1.5H12.764a.251.251,0,0,0-.156.055l-2.295,1.836a.5.5,0,0,1-.813-.391v-1.25a.25.25,0,0,0-.25-.25H9a1.5,1.5,0,0,1-1.5-1.5v-4A1.5,1.5,0,0,1,9,8.416h6a1.5,1.5,0,0,1,1.5,1.5Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z', 'M14.5,10.916a.5.5,0,0,0-.5-.5H10a.5.5,0,0,0,0,1h4A.5.5,0,0,0,14.5,10.916Z', 'M13.5,12.916a.5.5,0,0,0-.5-.5H10a.5.5,0,0,0,0,1h3A.5.5,0,0,0,13.5,12.916Z']],
  SmartWatchCircleWifi: ['smart-watch-circle-wifi', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5ZM12.083,16a1,1,0,1,1,1-1A1,1,0,0,1,12.083,16ZM15,13.1a.75.75,0,0,1-1.054.112,2.945,2.945,0,0,0-3.725,0,.75.75,0,1,1-.941-1.167,4.431,4.431,0,0,1,5.607,0A.751.751,0,0,1,15,13.1Zm1.554-3.465a.75.75,0,1,1-.941,1.167,5.581,5.581,0,0,0-7.059,0,.75.75,0,1,1-.941-1.167A7.067,7.067,0,0,1,16.554,9.632Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleTarget: ['smart-watch-circle-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z', 'M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm-.159,6.691a.656.656,0,0,1-.591.372h-.5a.25.25,0,0,0-.25.25V14.25a1,1,0,0,1-2,0V10.813a.25.25,0,0,0-.25-.25h-.5A.657.657,0,0,1,7.238,9.5L8.633,7.753a.99.99,0,0,1,.191-.24l.164-.2a.679.679,0,0,1,1.024,0l.164.2a.99.99,0,0,1,.191.24L11.762,9.5A.656.656,0,0,1,11.841,10.191ZM16.762,14.5l-1.395,1.744a1,1,0,0,1-.191.239l-.164.205a.656.656,0,0,1-1.024,0l-.164-.205a1,1,0,0,1-.191-.239L12.238,14.5a.656.656,0,0,1,.512-1.066h.5a.25.25,0,0,0,.25-.25V10.25a1,1,0,0,1,2,0v2.938a.25.25,0,0,0,.25.25h.5a.656.656,0,0,1,.512,1.066Z']],
  SmartWatchSquareHouse: ['smart-watch-square-house', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM12,13.5a1.25,1.25,0,0,0-1.25,1.25V16a.5.5,0,0,1-.5.5H8.75a.5.5,0,0,1-.5-.5V12.75A.25.25,0,0,0,8,12.5H7.089a.339.339,0,0,1-.318-.219.329.329,0,0,1,.1-.369l4.911-3.833a.341.341,0,0,1,.438,0l4.911,3.833a.329.329,0,0,1,.1.369.339.339,0,0,1-.318.219H16a.25.25,0,0,0-.25.25V16a.5.5,0,0,1-.5.5h-1.5a.5.5,0,0,1-.5-.5V14.75A1.25,1.25,0,0,0,12,13.5Z']],
  SmartWatchSquareHeart: ['smart-watch-square-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11a2.5,2.5,0,0,0,2,2.449c.162.033,11.5.051,11.5.051A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM16,12.681l-3.959,4.13a.25.25,0,0,1-.361,0l-3.959-4.13a2.449,2.449,0,0,1,3.464-3.463l.5.5a.252.252,0,0,0,.354,0l.5-.5A2.449,2.449,0,1,1,16,12.681Z']],
  SmartWatchSquareLocation: ['smart-watch-square-location', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-2,7c0,1.322-1.476,3.485-2.713,5.067A1,1,0,0,1,12,16.45a.991.991,0,0,1-.789-.385C9.975,14.483,8.5,12.319,8.5,11a3.5,3.5,0,0,1,7,0Z', 'M11.000 11.000 A1.000 1.000 0 1 0 13.000 11.000 A1.000 1.000 0 1 0 11.000 11.000 Z']],
  SmartWatchSquareStar: ['smart-watch-square-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM15.536,15.074a1,1,0,0,1-.251,1.158,1.019,1.019,0,0,1-1.2.133l-1.957-1.1a.254.254,0,0,0-.245,0l-1.957,1.1a1.028,1.028,0,0,1-1.2-.133,1,1,0,0,1-.25-1.158L9.2,13.429a.251.251,0,0,0-.087-.3l-1.231-.859a1.03,1.03,0,0,1-.3-1.154.987.987,0,0,1,.934-.611H9.99a.249.249,0,0,0,.233-.162l.845-2.229a1.053,1.053,0,0,1,1.856-.049.527.527,0,0,1,.022.049l.844,2.229a.251.251,0,0,0,.234.162h1.483a.985.985,0,0,1,.933.611,1,1,0,0,1-.238,1.1l-1.3.912a.25.25,0,0,0-.085.305Z']],
  SmartWatchSquareSleep: ['smart-watch-square-sleep', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM14.1,15.25a.75.75,0,0,1,0,1.5H10.5a1.251,1.251,0,0,1-1.06-1.914l3.566-5.7a.25.25,0,0,0-.212-.382H10.1a.75.75,0,1,1,0-1.5h3.6a1.251,1.251,0,0,1,1.063,1.91L11.19,14.867a.251.251,0,0,0,.212.383Z']],
  SmartWatchSquareTemperature: ['smart-watch-square-temperature', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM15,15.2a.75.75,0,0,1,0,1.5,3.75,3.75,0,0,1,0-7.5.75.75,0,0,1,0,1.5,2.25,2.25,0,0,0,0,4.5ZM11,8.45a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,11,8.45Z']],
  SmartWatchSquareText: ['smart-watch-square-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM9,15a1.5,1.5,0,0,1-1.5-1.5v-4A1.5,1.5,0,0,1,9,8h6a1.5,1.5,0,0,1,1.5,1.5v4A1.5,1.5,0,0,1,15,15H12.763a.25.25,0,0,0-.156.055L10.312,16.89A.5.5,0,0,1,9.5,16.5V15.25A.25.25,0,0,0,9.25,15Z', 'M10,11h4a.5.5,0,0,0,0-1H10a.5.5,0,0,0,0,1Z', 'M10,13h3a.5.5,0,0,0,0-1H10a.5.5,0,0,0,0,1Z']],
  SmartWatchSquareWifi: ['smart-watch-square-wifi', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-7.362,9.209A.75.75,0,1,1,9.2,12.042a4.432,4.432,0,0,1,5.608,0,.75.75,0,1,1-.942,1.167A2.944,2.944,0,0,0,10.138,13.209ZM13,15a1,1,0,1,1-1-1A1,1,0,0,1,13,15ZM8.471,10.8a.75.75,0,1,1-.942-1.167,7.068,7.068,0,0,1,8.942,0,.75.75,0,1,1-.942,1.167A5.58,5.58,0,0,0,8.471,10.8Z']],
  SmartWatchSquareTime: ['smart-watch-square-time', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.477,7.541c-.143,0-.521,0-.521.658s.378.656.521.656S8,8.855,8,8.2,7.62,7.541,7.477,7.541Z', 'M16.565,7.5c-.2,0-.522,0-.522,1.5s.327,1.5.522,1.5.521,0,.521-1.5S16.747,7.5,16.565,7.5Z', 'M12.5,8v.74a.249.249,0,0,0,.25.25h.229a.249.249,0,0,0,.25-.25V7.729A.229.229,0,0,0,13,7.5.5.5,0,0,0,12.5,8Z', 'M21,5.5A2.5,2.5,0,0,0,18.5,3H5.5A2.5,2.5,0,0,0,3,5.5v13A2.5,2.5,0,0,0,5.5,21h13A2.5,2.5,0,0,0,21,18.5ZM7.477,9.855A1.492,1.492,0,0,1,5.956,8.2,1.528,1.528,0,1,1,9,8.2V9.291A2,2,0,0,1,6.989,11.5a.5.5,0,0,1,0-1,.933.933,0,0,0,.729-.28.219.219,0,0,0-.17-.366ZM7.25,14.75h9.5a.75.75,0,0,1,0,1.5H7.25a.75.75,0,0,1,0-1.5ZM10.3,9.5a.5.5,0,1,1-.5.5A.5.5,0,0,1,10.3,9.5ZM9.8,8a.5.5,0,1,1,.5.5A.5.5,0,0,1,9.8,8Zm4.748,1.49a.5.5,0,0,1-.209.407.253.253,0,0,0-.105.2v.816a.5.5,0,0,1-1,0V10.24a.249.249,0,0,0-.25-.25H12a.5.5,0,0,1-.5-.5V8A1.5,1.5,0,0,1,13,6.5h.729a.5.5,0,0,1,.5.5V8.881a.25.25,0,0,0,.105.2A.5.5,0,0,1,14.543,9.49Zm2.022,2.01c-1.522,0-1.522-1.818-1.522-2.5s0-2.5,1.522-2.5S18.086,8.315,18.086,9,18.086,11.5,16.565,11.5Z', 'M16.18,22H7.82a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.443,1.329A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.443-1.329a.251.251,0,0,0-.035-.225A.248.248,0,0,0,16.18,22Z', 'M7.82,2h8.36a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.582,1.671A.251.251,0,0,0,7.82,2Z']],
  SmartWatchSquareUpload: ['smart-watch-square-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-1,8A4.5,4.5,0,1,1,12,7.5,4.505,4.505,0,0,1,16.5,12Z', 'M12.354,9.646a.5.5,0,0,0-.708,0l-1.5,1.5A.5.5,0,0,0,10.5,12h.75a.25.25,0,0,1,.25.25V14a.5.5,0,0,0,1,0V12.25a.25.25,0,0,1,.25-.25h.75a.5.5,0,0,0,.354-.854Z']],
  SmartWatchCirclePlayAlternate: ['smart-watch-circle-play-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M15.718,13.216a1.112,1.112,0,0,0,0-1.929l-4.5-2.628a1.15,1.15,0,0,0-1.137-.014,1.12,1.12,0,0,0-.581.978v5.258a1.12,1.12,0,0,0,.582.978,1.158,1.158,0,0,0,1.135-.014Z']],
  SmartWatchSquareBrightness: ['smart-watch-square-brightness', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM9.75,15a1,1,0,1,1-1,1A1,1,0,0,1,9.75,15Zm-1-7a1,1,0,1,1,1,1A1,1,0,0,1,8.75,8ZM10,12.25a2,2,0,1,1,2,2A2,2,0,0,1,10,12.25ZM14.25,15a1,1,0,1,1-1,1A1,1,0,0,1,14.25,15Zm0-6a1,1,0,1,1,1-1A1,1,0,0,1,14.25,9Zm-7,2a1,1,0,1,1-1,1A1,1,0,0,1,7.25,11Zm9.5,2a1,1,0,1,1,1-1A1,1,0,0,1,16.75,13Z']],
  SmartWatchSquareMusic: ['smart-watch-square-music', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm-1.75,9.25A1.75,1.75,0,1,1,14,11.5a.255.255,0,0,0,.177-.073.251.251,0,0,0,.073-.177V8.887a.252.252,0,0,0-.1-.2.249.249,0,0,0-.224-.034l-3.3.848a.254.254,0,0,0-.12.222v5.03A1.75,1.75,0,1,1,8.75,13a.255.255,0,0,0,.177-.073A.251.251,0,0,0,9,12.75V9.72a1.747,1.747,0,0,1,1.2-1.66l3.3-.848a1.731,1.731,0,0,1,1.526.256,1.751,1.751,0,0,1,.727,1.419Z']],
  SmartWatchCircleMailAlternate: ['smart-watch-circle-mail-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M16.574,10.835a.177.177,0,0,0-.182,0l-3.536,2.224a1.612,1.612,0,0,1-1.712,0L7.608,10.84a.18.18,0,0,0-.275.153v3.425A1.082,1.082,0,0,0,8.41,15.5h7.179a1.082,1.082,0,0,0,1.077-1.084V10.993A.18.18,0,0,0,16.574,10.835Z', 'M15.589,8.5H8.41A1.051,1.051,0,0,0,7.333,9.524a.053.053,0,0,0,.025.043l4.356,2.583a.566.566,0,0,0,.571,0l4.356-2.584a.048.048,0,0,0,.025-.042A1.051,1.051,0,0,0,15.589,8.5Z']],
  SmartWatchSquareDownloadAlternate: ['smart-watch-square-download-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,16.5A4.5,4.5,0,1,0,7.5,12,4.505,4.505,0,0,0,12,16.5ZM10.038,12.31A.5.5,0,0,1,10.5,12h.75a.25.25,0,0,0,.25-.25V10a.5.5,0,0,1,1,0v1.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.353.853l-1.5,1.5a.5.5,0,0,1-.707,0l-1.5-1.5A.5.5,0,0,1,10.038,12.31Z']],
  SmartWatchCircleSoundAlternate: ['smart-watch-circle-sound-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M16.3,8.281a.75.75,0,0,0-1.168.942,4.39,4.39,0,0,1,0,5.558.75.75,0,0,0,1.168.942A5.881,5.881,0,0,0,16.3,8.281Z', 'M14.584,9.781a.75.75,0,0,0-1.168.941,2.026,2.026,0,0,1,0,2.559.75.75,0,0,0,1.168.941A3.514,3.514,0,0,0,14.584,9.781Z', 'M12,15.5a.5.5,0,0,0,.5-.5V9a.5.5,0,0,0-.5-.5h-.5a3.5,3.5,0,0,0-3.083,1.866A.251.251,0,0,1,8.2,10.5H7a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5H8.2a.249.249,0,0,1,.221.133A3.5,3.5,0,0,0,11.5,15.5Z']],
  SmartWatchSquareSettingsAlternate: ['smart-watch-square-settings-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.437,12.116a.171.171,0,0,1,0-.229l.686-.74A1.393,1.393,0,0,0,14.8,8.841l-.982.227a.16.16,0,0,1-.19-.112l-.295-.968h0a1.388,1.388,0,0,0-2.657,0l-.294.968a.161.161,0,0,1-.191.112l-.981-.227a1.393,1.393,0,0,0-1.33,2.306l.687.74a.169.169,0,0,1,0,.229l-.685.74a1.393,1.393,0,0,0,1.329,2.307l.981-.228a.164.164,0,0,1,.191.112l.294.969a1.388,1.388,0,0,0,2.657,0l.295-.969a.163.163,0,0,1,.19-.112l.982.228a1.393,1.393,0,0,0,1.33-2.306ZM12,13.5A1.5,1.5,0,1,1,13.5,12,1.5,1.5,0,0,1,12,13.5Z']],
  SmartWatchSquareUploadAlternate: ['smart-watch-square-upload-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,7.5A4.5,4.5,0,1,0,16.5,12,4.5,4.5,0,0,0,12,7.5Zm1.962,4.191A.5.5,0,0,1,13.5,12h-.75a.25.25,0,0,0-.25.25V14a.5.5,0,1,1-1,0v-1.75a.25.25,0,0,0-.25-.25H10.5a.5.5,0,0,1-.354-.854l1.5-1.5a.5.5,0,0,1,.707,0l1.5,1.5A.5.5,0,0,1,13.962,11.693Z']],
  SmartWatchCirclePlay: ['smart-watch-circle-play', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm3.526,9.714-4.5,2.629a1.157,1.157,0,0,1-1.136.014,1.12,1.12,0,0,1-.582-.978V9.621a1.12,1.12,0,0,1,.582-.979,1.156,1.156,0,0,1,1.135.014l4.5,2.63a1.113,1.113,0,0,1,0,1.928Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchSquareSound: ['smart-watch-square-sound', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.749a.248.248,0,0,0,.2-.1.251.251,0,0,0,.035-.225L15.975.341A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.42a.251.251,0,0,0,.035.225.248.248,0,0,0,.2.1Z', 'M7.57,21.249a.251.251,0,0,0-.238.329l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.238-.329Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM13.786,9.98a.5.5,0,1,1,.777-.628,4.184,4.184,0,0,1,0,5.3.5.5,0,1,1-.777-.628A3.2,3.2,0,0,0,13.786,9.98ZM12,8.5a.5.5,0,0,1,.5.5v6a.5.5,0,0,1-.5.5h-.5a3.5,3.5,0,0,1-3.083-1.866A.25.25,0,0,0,8.2,13.5H7a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,.5-.5H8.2a.249.249,0,0,0,.221-.133A3.5,3.5,0,0,1,11.5,8.5Zm3.974,7.814a.5.5,0,1,1-.778-.628,5.83,5.83,0,0,0,0-7.372.5.5,0,0,1,.778-.628A6.824,6.824,0,0,1,15.974,16.313Z']],
  SmartWatchSquareCashAlternate: ['smart-watch-square-cash-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,3H16.922a.249.249,0,0,1-.24-.182L15.98.364A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.362l-.7,2.456A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3V6A3,3,0,0,0,18,3Zm1,15a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M14.591,13.91a2.08,2.08,0,0,0-1.315-1.942l-2.064-.825A.592.592,0,0,1,11.433,10h2.033a.75.75,0,0,0,0-1.5h-.5a.25.25,0,0,1-.25-.25V8a.75.75,0,1,0-1.5,0v.3a.248.248,0,0,1-.2.244,2.092,2.092,0,0,0-.36,3.992l2.063.825A.592.592,0,0,1,12.5,14.5H10.466a.75.75,0,1,0,0,1.5h.5a.249.249,0,0,1,.25.25v.25a.75.75,0,0,0,1.5,0v-.3a.248.248,0,0,1,.2-.244A2.1,2.1,0,0,0,14.591,13.91Z']],
  SmartWatchWrist: ['smart-watch-wrist', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.248,7.635A1,1,0,1,0,6.633,9.077a.753.753,0,0,1,1.016,0A1,1,0,1,0,9.033,7.635,2.759,2.759,0,0,0,5.248,7.635Z', 'M11.461,6.743a1,1,0,0,0-.028-1.414,6.253,6.253,0,0,0-8.584,0A1,1,0,0,0,4.234,6.771a4.236,4.236,0,0,1,5.814,0A1,1,0,0,0,11.461,6.743Z', 'M1.833,4.465a7.733,7.733,0,0,1,10.615,0,1,1,0,1,0,1.385-1.442,9.75,9.75,0,0,0-13.385,0A1,1,0,0,0,1.833,4.465Z', 'M4.284,19.836a.25.25,0,0,0-.245-.2H3.891a1,1,0,0,1-1-1v-5a1,1,0,0,1,1-1h.148a.25.25,0,0,0,.245-.2l.1-.5a.25.25,0,0,0-.245-.3H.641a.5.5,0,0,0-.5.5v8a.5.5,0,0,0,.5.5h3.5a.249.249,0,0,0,.245-.3Z', 'M23.838,18.809l-.819-6.192a3.479,3.479,0,0,0-3.462-2.981H15.469a5.5,5.5,0,0,0-2.729.725L10.624,11.57a.5.5,0,0,1-.249.066H8.64a.251.251,0,0,0-.245.3l.1.5a.25.25,0,0,0,.245.2h.148a1,1,0,0,1,1,1v5a1,1,0,0,1-1,1H8.743a.25.25,0,0,0-.245.2l-.1.5a.251.251,0,0,0,.052.209.248.248,0,0,0,.193.091h1.533a.5.5,0,0,1,.384.181l.7.841a5.483,5.483,0,0,0,4.225,1.978h2.158a2.5,2.5,0,0,0,2.406-1.817.251.251,0,0,1,.241-.183H21.36a2.5,2.5,0,0,0,2.478-2.827Z', 'M4.359 14.136 L8.359 14.136 L8.359 18.136 L4.359 18.136 Z']],
  SmartWatchCircleMicrophone: ['smart-watch-circle-microphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm-1.917,6a2,2,0,1,1,4,0v2a2,2,0,0,1-4,0Zm2.706,5.938a.25.25,0,0,0-.206.246V17a.5.5,0,0,1-1,0V15.683a.249.249,0,0,0-.205-.246A4.007,4.007,0,0,1,8.083,11.5a.5.5,0,0,1,1,0,3,3,0,0,0,6,0,.5.5,0,1,1,1,0A4.006,4.006,0,0,1,12.789,15.437Z', 'M7.379,3.05a.125.125,0,0,0,.135.015,9.972,9.972,0,0,1,8.972,0,.125.125,0,0,0,.177-.144L15.983.37A.5.5,0,0,0,15.5,0h-7A.5.5,0,0,0,8.017.37l-.68,2.551A.125.125,0,0,0,7.379,3.05Z', 'M16.621,20.948a.127.127,0,0,0-.135-.014,9.98,9.98,0,0,1-8.972,0,.124.124,0,0,0-.177.143l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.55A.126.126,0,0,0,16.621,20.948Z']],
  SmartWatchSquareBellAlternate: ['smart-watch-square-bell-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.5,13a.5.5,0,0,1-.5-.5v-2a3,3,0,1,0-6,0v2a.5.5,0,0,1-.5.5.5.5,0,0,0,0,1h7a.5.5,0,0,0,0-1Z', 'M12.866,15H11.133a.5.5,0,0,0-.433.75,1.5,1.5,0,0,0,2.6,0,.5.5,0,0,0-.433-.75Z']],
  SmartWatchSquareDataAlternate: ['smart-watch-square-data-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M9.762,7.092a.68.68,0,0,0-1.025,0L6.987,9.279A.656.656,0,0,0,7.5,10.345H8a.25.25,0,0,1,.25.25v3.438a1,1,0,1,0,2,0V10.6a.25.25,0,0,1,.25-.25H11a.656.656,0,0,0,.512-1.066Z', 'M16,13.22h-.5a.249.249,0,0,1-.25-.25V10.033a1,1,0,0,0-2,0V12.97a.249.249,0,0,1-.25.25h-.5a.657.657,0,0,0-.513,1.067l1.75,2.187a.657.657,0,0,0,1.025,0l1.75-2.187A.657.657,0,0,0,16,13.22Z']],
  SmartWatchCircleLocationAlternate: ['smart-watch-circle-location-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.245.245,0,0,1-.109-.148L15.983.374A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.78A.245.245,0,0,1,7,3.928,9.5,9.5,0,0,0,7,20.077a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M12,7.552a3.5,3.5,0,0,0-3.5,3.5c0,1.319,1.474,3.483,2.711,5.065A.989.989,0,0,0,12,16.5a1.009,1.009,0,0,0,.787-.384c1.237-1.582,2.713-3.745,2.713-5.067A3.5,3.5,0,0,0,12,7.552Zm0,2.5a1,1,0,1,1-1,1A1,1,0,0,1,12,10.052Z']],
  SmartWatchCircleGraphLine: ['smart-watch-circle-graph-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.94,12.886l-.519-.866a.25.25,0,0,0-.446.033l-1.216,2.956a1.249,1.249,0,0,1-2.289-.016L9.606,9.613a.249.249,0,0,0-.452-.043L7.232,12.877a.752.752,0,0,1-.649.373h-2.7a.249.249,0,0,0-.245.295,8.5,8.5,0,0,0,16.718,0,.249.249,0,0,0-.053-.205.251.251,0,0,0-.193-.09h-3.53A.751.751,0,0,1,15.94,12.886Z', 'M8.423,7.845A1.267,1.267,0,0,1,9.6,7.255a1.25,1.25,0,0,1,1.035.753l1.788,5.161a.25.25,0,0,0,.467.013l1.092-2.653A1.249,1.249,0,0,1,16.2,10.4l.739,1.232a.25.25,0,0,0,.215.122h3.085a.25.25,0,0,0,.249-.265,8.5,8.5,0,0,0-16.968,0,.25.25,0,0,0,.249.265H6.008a.251.251,0,0,0,.216-.125Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleLocation: ['smart-watch-circle-location', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm.871,12.616a1,1,0,0,1-.786.384,1.007,1.007,0,0,1-.789-.384c-1.237-1.581-2.713-3.744-2.713-5.066a3.5,3.5,0,0,1,7,0C15.583,12.368,14.109,14.532,12.871,16.115Z', 'M7.379,3.05a.125.125,0,0,0,.135.015,9.972,9.972,0,0,1,8.972,0,.125.125,0,0,0,.177-.144L15.983.37A.5.5,0,0,0,15.5,0h-7A.5.5,0,0,0,8.017.37l-.68,2.551A.125.125,0,0,0,7.379,3.05Z', 'M16.663,21.078a.125.125,0,0,0-.177-.144,9.98,9.98,0,0,1-8.972,0,.124.124,0,0,0-.177.143l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371Z', 'M11.083 11.049 A1.000 1.000 0 1 0 13.083 11.049 A1.000 1.000 0 1 0 11.083 11.049 Z']],
  SmartWatchSquareMissedCall: ['smart-watch-square-missed-call', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM15.854,9.9a.5.5,0,0,1-.354.854h-2a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.854-.354l.469.47a.25.25,0,0,0,.354,0L16.146,6.9a.5.5,0,1,1,.708.707l-1.47,1.47a.25.25,0,0,0,0,.354ZM11.166,14.09a.248.248,0,0,0,.342-.01l.971-.971a1.272,1.272,0,0,1,.905-.376h0a1.274,1.274,0,0,1,.908.376l.83.831a1.285,1.285,0,0,1,0,1.814l-.456.455a1.681,1.681,0,0,1-2.107.213,18.7,18.7,0,0,1-5.234-5.233,1.682,1.682,0,0,1,.21-2.106L8,8.626a1.289,1.289,0,0,1,1.817,0l.83.833a1.282,1.282,0,0,1,0,1.813l-.973.971a.249.249,0,0,0-.01.342A17.543,17.543,0,0,0,11.166,14.09Z']],
  SmartWatchCircleBellAlternate: ['smart-watch-circle-bell-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M15.5,13a.5.5,0,0,1-.5-.5v-2a3,3,0,1,0-6,0v2a.5.5,0,0,1-.5.5.5.5,0,0,0,0,1h7a.5.5,0,0,0,0-1Z', 'M12,16.5a1.5,1.5,0,0,0,1.3-.75.5.5,0,0,0-.433-.75H11.133a.5.5,0,0,0-.433.75A1.5,1.5,0,0,0,12,16.5Z']],
  SmartWatchCirle: ['smart-watch-cirle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z', 'M3.500 12.000 A8.500 8.500 0 1 0 20.500 12.000 A8.500 8.500 0 1 0 3.500 12.000 Z']],
  SmartWatchSquareGraph: ['smart-watch-square-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM17,15.75H7a.75.75,0,0,1,0-1.5H8A.25.25,0,0,0,8.25,14V8.5a.75.75,0,0,1,1.5,0V14a.25.25,0,0,0,.25.25h1a.25.25,0,0,0,.25-.25V10.125a.75.75,0,0,1,1.5,0V14a.25.25,0,0,0,.25.25h1a.25.25,0,0,0,.25-.25V11.75a.75.75,0,0,1,1.5,0V14a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5Z']],
  SmartWatchSquarePower: ['smart-watch-square-power', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM12,15.25A3.251,3.251,0,0,0,14.3,9.7a.75.75,0,1,1,1.06-1.06,4.75,4.75,0,1,1-6.716,0A.75.75,0,1,1,9.7,9.7,3.251,3.251,0,0,0,12,15.25Zm-.75-4.322V7.5a.75.75,0,0,1,1.5,0v3.428a.75.75,0,0,1-1.5,0Z']],
  SmartWatchCircleNavigationAlternate: ['smart-watch-circle-navigation-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.25.25,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M14.988,8.047,7.21,11.582a.5.5,0,0,0,.162.953l3.266.3a.251.251,0,0,1,.226.227l.3,3.266a.5.5,0,0,0,.953.162L15.65,8.709a.5.5,0,0,0-.662-.662Z']],
  SmartWatchCircleCashAlternate: ['smart-watch-circle-cash-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.247.247,0,0,1,.109.148l.908,3.406A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.369l.935-3.427a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M14.75,13.41a2.081,2.081,0,0,0-1.316-1.942l-2.062-.825A.592.592,0,0,1,11.591,9.5h2.034a.75.75,0,0,0,0-1.5h-.5a.25.25,0,0,1-.25-.25V7.5a.75.75,0,1,0-1.5,0v.3a.248.248,0,0,1-.2.244,2.092,2.092,0,0,0-.359,3.992l2.063.825A.592.592,0,0,1,12.658,14H10.625a.75.75,0,0,0,0,1.5h.5a.249.249,0,0,1,.25.25V16a.75.75,0,0,0,1.5,0v-.3a.248.248,0,0,1,.2-.244A2.1,2.1,0,0,0,14.75,13.41Z']],
  SmartWatchSquareDumbbell: ['smart-watch-square-dumbbell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4Zm.75,8a.75.75,0,0,1-.75.75h-.75a.25.25,0,0,0-.25.25v.5A1.5,1.5,0,0,1,15,15H13.5a.5.5,0,0,1-.5-.5V13a.25.25,0,0,0-.25-.25h-1.5A.25.25,0,0,0,11,13v1.5a.5.5,0,0,1-.5.5H9a1.5,1.5,0,0,1-1.5-1.5V13a.25.25,0,0,0-.25-.25H6.5a.75.75,0,0,1,0-1.5h.75A.25.25,0,0,0,7.5,11v-.5A1.5,1.5,0,0,1,9,9h1.5a.5.5,0,0,1,.5.5V11a.25.25,0,0,0,.25.25h1.5A.25.25,0,0,0,13,11V9.5a.5.5,0,0,1,.5-.5H15a1.5,1.5,0,0,1,1.5,1.5V11a.25.25,0,0,0,.25.25h.75A.75.75,0,0,1,18.25,12Z']],
  SmartWatchCircleGraphAlternate: ['smart-watch-circle-graph-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M17,13.752H16a.25.25,0,0,1-.25-.25v-2.25a.75.75,0,0,0-1.5,0V13.5a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25V9.627a.75.75,0,0,0-1.5,0V13.5a.25.25,0,0,1-.25.25H10a.25.25,0,0,1-.25-.25V8a.75.75,0,1,0-1.5,0v5.5a.25.25,0,0,1-.25.25H7a.75.75,0,0,0,0,1.5H17a.75.75,0,0,0,0-1.5Z']],
  SmartWatchCircleRingingAlternate: ['smart-watch-circle-ringing-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M15.366,11.175A11.277,11.277,0,0,0,12,10.753a12.057,12.057,0,0,0-3.189.369C6.872,11.657,6.75,12.6,6.75,13v1a1.819,1.819,0,0,0,1.75,1.75h1A1.819,1.819,0,0,0,11.25,14v-1.49a.25.25,0,0,1,.242-.25c.33-.01.685-.01,1.016,0a.25.25,0,0,1,.242.25V14a1.821,1.821,0,0,0,1.718,1.749H15.5A1.819,1.819,0,0,0,17.252,14V13C17.252,12,16.321,11.466,15.366,11.175Z', 'M11.25,7V8.5a.75.75,0,1,0,1.5,0V7a.75.75,0,1,0-1.5,0Z', 'M14.187,9.728a.749.749,0,0,0,.994-.369L15.806,8a.75.75,0,0,0-1.363-.625l-.625,1.363A.748.748,0,0,0,14.187,9.728Z', 'M8.818,9.359a.75.75,0,1,0,1.363-.625L9.556,7.371A.75.75,0,0,0,8.193,8Z']],
  SmartWatchCircleTargetAlternate: ['smart-watch-circle-target-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.928a.25.25,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.369l.935-3.427a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12Zm-8.031,7.359a7.5,7.5,0,1,1,5.89-5.89A7.515,7.515,0,0,1,13.469,19.361Z', 'M10.012,7.311a.681.681,0,0,0-1.025,0L7.237,9.5a.656.656,0,0,0,.513,1.066H8.5a.25.25,0,0,1,.25.25v3.438a.75.75,0,0,0,1.5,0V10.815a.25.25,0,0,1,.25-.25h.75A.656.656,0,0,0,11.762,9.5Z', 'M16.841,13.812a.656.656,0,0,0-.591-.372H15.5a.25.25,0,0,1-.25-.25V10.253a.75.75,0,0,0-1.5,0V13.19a.25.25,0,0,1-.25.25h-.75a.657.657,0,0,0-.513,1.067l1.75,2.187a.657.657,0,0,0,1.025,0l1.75-2.187A.658.658,0,0,0,16.841,13.812Z']],
  SmartWatchSquareDumbbellAlternate: ['smart-watch-square-dumbbell-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3V6A3,3,0,0,0,18,3Zm1,15a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M18.25,12a.75.75,0,0,0-.75-.75h-.75A.25.25,0,0,1,16.5,11v-.5A1.5,1.5,0,0,0,15,9H13.5a.5.5,0,0,0-.5.5V11a.25.25,0,0,1-.25.25h-1.5A.25.25,0,0,1,11,11V9.5a.5.5,0,0,0-.5-.5H9a1.5,1.5,0,0,0-1.5,1.5V11a.25.25,0,0,1-.25.25H6.5a.75.75,0,0,0,0,1.5h.75A.25.25,0,0,1,7.5,13v.5A1.5,1.5,0,0,0,9,15h1.5a.5.5,0,0,0,.5-.5V13a.25.25,0,0,1,.25-.25h1.5A.25.25,0,0,1,13,13v1.5a.5.5,0,0,0,.5.5H15a1.5,1.5,0,0,0,1.5-1.5V13a.25.25,0,0,1,.25-.25h.75A.75.75,0,0,0,18.25,12Z']],
  SmartWatchSquareHeartAlternate: ['smart-watch-square-heart-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M16.741,9.524a2.449,2.449,0,0,0-3.922-.637l-.5.5a.25.25,0,0,1-.354,0l-.5-.5A2.449,2.449,0,0,0,8,12.351l3.959,4.13a.252.252,0,0,0,.361,0l3.959-4.13A2.449,2.449,0,0,0,16.741,9.524Z']],
  SmartWatchSquareMusicAlternate: ['smart-watch-square-music-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.75,8.889a1.757,1.757,0,0,0-.727-1.42A1.729,1.729,0,0,0,13.5,7.214l-3.3.848A1.747,1.747,0,0,0,9,9.722v3.03a.25.25,0,0,1-.25.25,1.75,1.75,0,1,0,1.75,1.75V9.722a.254.254,0,0,1,.12-.222l3.3-.848a.25.25,0,0,1,.329.237v2.363a.25.25,0,0,1-.25.25,1.75,1.75,0,1,0,1.75,1.75Z']],
  SmartWatchSquareSoundAlternate: ['smart-watch-square-sound-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.362l-.7,2.456A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M15.313,8.169A.751.751,0,0,0,15.2,9.224a4.391,4.391,0,0,1,0,5.557.751.751,0,0,0,1.168.943,5.885,5.885,0,0,0,0-7.443A.75.75,0,0,0,15.313,8.169Z', 'M14.65,9.782a.75.75,0,0,0-1.168.941,2.026,2.026,0,0,1,0,2.559.75.75,0,0,0,1.168.941A3.511,3.511,0,0,0,14.65,9.782Z', 'M12.066,8.5h-.5a3.5,3.5,0,0,0-3.083,1.866.25.25,0,0,1-.221.134h-1.2a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h1.2a.249.249,0,0,1,.221.133A3.5,3.5,0,0,0,11.566,15.5h.5a.5.5,0,0,0,.5-.5V9A.5.5,0,0,0,12.066,8.5Z']],
  SmartWatchSquareRingingAlternate: ['smart-watch-square-ringing-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M12,10.753c-1.074,0-5.25.122-5.25,2.249v1a1.819,1.819,0,0,0,1.75,1.75h1A1.819,1.819,0,0,0,11.248,14v-1.49a.25.25,0,0,1,.242-.25c.33-.01.685-.01,1.016,0a.25.25,0,0,1,.242.25V14a1.869,1.869,0,0,0,1.75,1.75h1A1.819,1.819,0,0,0,17.248,14V13C17.248,10.915,13.229,10.753,12,10.753Z', 'M12,9.252a.75.75,0,0,0,.75-.75V7a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,12,9.252Z', 'M14.185,9.728a.748.748,0,0,0,.994-.369L15.8,8a.75.75,0,1,0-1.363-.625l-.625,1.363A.748.748,0,0,0,14.185,9.728Z', 'M8.816,9.359a.75.75,0,1,0,1.363-.625L9.554,7.371A.75.75,0,0,0,8.191,8Z']],
  SmartWatchSquareTextAlternate: ['smart-watch-square-text-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6a3,3,0,0,0-3-3H16.922a.249.249,0,0,1-.24-.182L15.98.365A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.481.363l-.7,2.455A.248.248,0,0,1,7.077,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H7.077a.249.249,0,0,1,.24.181l.7,2.456A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.48-.363l.7-2.456a.25.25,0,0,1,.24-.181H18a3,3,0,0,0,3-3ZM19,18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z', 'M16.5,9.085a1.5,1.5,0,0,0-1.5-1.5H9a1.5,1.5,0,0,0-1.5,1.5v4a1.5,1.5,0,0,0,1.5,1.5h.25a.25.25,0,0,1,.25.25v1.25a.5.5,0,0,0,.812.391l2.3-1.836a.251.251,0,0,1,.156-.055H15a1.5,1.5,0,0,0,1.5-1.5Zm-6.5,3.5a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Zm0-2.25a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z']],
  SmartWatchCircleBell: ['smart-watch-circle-bell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm1.382,12.75a1.5,1.5,0,0,1-2.6,0,.5.5,0,0,1,.433-.75H12.95a.5.5,0,0,1,.432.75Zm2.2-1.75h-7a.5.5,0,1,1,0-1,.5.5,0,0,0,.5-.5V11a3,3,0,0,1,6,0v2a.5.5,0,0,0,.5.5.5.5,0,0,1,0,1Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchCircleGraph: ['smart-watch-circle-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm5.083,11.75h-10a.75.75,0,1,1,0-1.5h1a.25.25,0,0,0,.25-.25V8a.75.75,0,1,1,1.5,0v5.5a.25.25,0,0,0,.25.25h1a.25.25,0,0,0,.25-.25V9.625a.75.75,0,0,1,1.5,0V13.5a.25.25,0,0,0,.25.25h1a.25.25,0,0,0,.25-.25V11.25a.75.75,0,0,1,1.5,0V13.5a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchSquareGraphLine: ['smart-watch-square-graph-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M6.068,12.25l2.272-3.9a1.269,1.269,0,0,1,1.178-.59,1.25,1.25,0,0,1,1.035.753l1.787,5.161a.25.25,0,0,0,.468.013L13.9,11.029a1.267,1.267,0,0,1,1.091-.74,1.243,1.243,0,0,1,1.122.607l.813,1.354H19.75A.25.25,0,0,0,20,12V6.5A2.5,2.5,0,0,0,17.5,4H6.5A2.5,2.5,0,0,0,4,6.5V12a.25.25,0,0,0,.25.25Z', 'M16.5,13.75a.751.751,0,0,1-.644-.364l-.519-.866a.249.249,0,0,0-.445.033l-1.216,2.956a1.274,1.274,0,0,1-1.142.741H12.5a1.254,1.254,0,0,1-1.113-.756l-1.864-5.38a.249.249,0,0,0-.452-.043L7.148,13.377a.749.749,0,0,1-.648.373H4.25A.25.25,0,0,0,4,14v3.5A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V14a.25.25,0,0,0-.25-.25Z']],
  SmartWatchCircleStar: ['smart-watch-circle-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm4.272,8.211-1.3.912a.252.252,0,0,0-.086.305l.718,1.646a1,1,0,0,1-.251,1.158,1.028,1.028,0,0,1-1.2.133l-1.957-1.1a.254.254,0,0,0-.245,0L10,15.865a1.02,1.02,0,0,1-1.2-.133,1,1,0,0,1-.251-1.158l.716-1.645a.249.249,0,0,0-.086-.3l-1.232-.859a1.029,1.029,0,0,1-.3-1.154A.986.986,0,0,1,8.576,10h1.482a.25.25,0,0,0,.234-.162l.845-2.229a1.053,1.053,0,0,1,1.856-.049.54.54,0,0,1,.023.049l.844,2.229a.251.251,0,0,0,.234.162h1.482a.985.985,0,0,1,.934.612A1,1,0,0,1,16.272,11.711Z', 'M7.379,3.051a.125.125,0,0,0,.135.014,9.98,9.98,0,0,1,8.972,0,.125.125,0,0,0,.177-.144l-.68-2.55A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371l-.68,2.551A.125.125,0,0,0,7.379,3.051Z', 'M16.621,20.949a.125.125,0,0,0-.135-.015,9.972,9.972,0,0,1-8.972,0,.125.125,0,0,0-.177.144l.68,2.551A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.483-.371l.68-2.551A.125.125,0,0,0,16.621,20.949Z']],
  SmartWatchSquareSettings: ['smart-watch-square-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM8.562,11.886l-.687-.741a1.393,1.393,0,0,1,1.33-2.306l.982.227a.159.159,0,0,0,.19-.112l.295-.968a1.388,1.388,0,0,1,2.656,0h0l.295.968a.16.16,0,0,0,.19.112l.982-.227a1.392,1.392,0,0,1,1.329,2.306l-.686.741a.17.17,0,0,0,0,.228l.688.741a1.393,1.393,0,0,1-1.33,2.306l-.982-.228a.163.163,0,0,0-.19.112l-.295.969a1.387,1.387,0,0,1-2.656,0l-.295-.969a.162.162,0,0,0-.19-.112l-.982.228a1.393,1.393,0,0,1-1.329-2.307l.686-.74A.169.169,0,0,0,8.562,11.886Z', 'M10.500 12.000 A1.500 1.500 0 1 0 13.500 12.000 A1.500 1.500 0 1 0 10.500 12.000 Z']],
  SmartWatchSquareMicrophone: ['smart-watch-square-microphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.43,2.75a.251.251,0,0,0,.238-.329L15.975.342A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.475.342L7.332,2.421a.251.251,0,0,0,.238.329Z', 'M7.57,21.25a.248.248,0,0,0-.2.1.251.251,0,0,0-.035.225l.693,2.079A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.475-.342l.693-2.079a.251.251,0,0,0-.035-.225.248.248,0,0,0-.2-.1Z', 'M17.5,4H6.5A2.5,2.5,0,0,0,4,6.5v11A2.508,2.508,0,0,0,6.5,20h11A2.5,2.5,0,0,0,20,17.5V6.5A2.5,2.5,0,0,0,17.5,4ZM8,11.5a.5.5,0,0,1,1,0,3,3,0,0,0,6,0,.5.5,0,0,1,1,0,4.006,4.006,0,0,1-3.294,3.937.251.251,0,0,0-.206.246V17a.5.5,0,0,1-1,0V15.683a.251.251,0,0,0-.206-.246A4.006,4.006,0,0,1,8,11.5Zm2,0v-2a2,2,0,0,1,4,0v2a2,2,0,0,1-4,0Z']],
  SmartWatchCircleHomeAlternate: ['smart-watch-circle-home-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12A9.5,9.5,0,0,0,17,3.927a.245.245,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.484.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.368l.935-3.428a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12ZM12,19.5A7.5,7.5,0,1,1,19.5,12,7.509,7.509,0,0,1,12,19.5Z', 'M17.129,10.914l-4.91-3.833a.343.343,0,0,0-.439,0L6.87,10.914a.329.329,0,0,0-.1.369.341.341,0,0,0,.319.219H8a.25.25,0,0,1,.25.25V15a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-1.25a1.25,1.25,0,0,1,2.5,0V15a.5.5,0,0,0,.5.5h1.5a.5.5,0,0,0,.5-.5v-3.25A.25.25,0,0,1,16,11.5h.91a.34.34,0,0,0,.319-.219A.329.329,0,0,0,17.129,10.914Z']]
};
exports["default"] = _default;